import { BASE_URL } from "@utils/constants";
import {
  addAssignedFiles,
  addAssignedFolders,
  addAssignedProjects,
  addValidatorAdminDetails,
  addValidators,
  setSelectedFile,
} from "@store/slices/validatorAdminSlice";
import {
  addValidatorDetails,
  addAssignedFiles as addValidatorAssignedFiles,
  addAssignedFolders as addValidatorAssignedFolders,
  setSelectedAssignedProjectId,
  setSelectedAssignedFolderId,
  setSelectedAssignedFileId,
  setSelectedFile as setValidatorSelectedFile,
  setTargetLanguageId,
} from "@store/slices/validatorSlice";
import {
  setValidatorProjects,
  setLoading,
  setError
} from "@store/slices/validatorProjectSlice";
import apiClient from "@/services/api/apiClient";

export const fetchAllValidatorAdminDetails = () => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    const data = await apiClient(
      BASE_URL + "api/validatorAdmin/getAllValidatorAdminDetails",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          "Authorization": `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    dispatch(addValidatorAdminDetails(data));
    return data;
  } catch (error) {
    console.error("Error fetching validator admin details:", error);
  }
};

export const fetchAllValidators = (langId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    const data = await apiClient(
      BASE_URL + `api/validatorAdmin/getAllValidatorUserByLanguageId?langId=${langId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          "Authorization": `Bearer ${token}`
        },
        credentials: "include",
      }
    );

    console.log("Fetched validators:", data.data);
    dispatch(addValidators(data.data));
    return data.data;
  } catch (error) {
    console.error("Error fetching validators:", error);
    return [];
  }
};

export const fetchSelectedValidatorFileData = (fileId) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;

  try {
    console.log("Fetching assigned language details for file:", fileId);
    const data = await apiClient(
      BASE_URL + `api/validatorAdmin/filesByFileId?fileId=${fileId}&validatorAdminId=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          "Authorization": `Bearer ${token}`
        },
        credentials: "include",
      }
    );

    dispatch(setSelectedFile(data.data));
    if (data.data && data.data.targetLanguageId) {
      dispatch(setTargetLanguageId(data.data.targetLanguageId));
    }
    return data.data;
  } catch (error) {
    console.error("Error fetching validator file data:", error);
    return null;
  }
};

export const assignValidatorAPI = (assignments) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    const data = await apiClient(
      BASE_URL + `api/validatorAdmin/assignVU?validatorAdminId=${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          "Authorization": `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify(assignments),
      }
    );


    console.log("Assignment response:", data);

    dispatch(fetchAllValidatorAdminDetails());
    return data;
  } catch (error) {
    console.error("Error assigning validators:", error);
    throw error;
  }
};

// New functions for validator dashboard

// Fetch all assigned files for a validator
export const fetchValidatorAssignedFiles = (validatorId) => async (dispatch) => {
  try {
    console.log(`Fetching assigned files for validator: ${validatorId}`);
    const data = await apiClient(
      BASE_URL + `api/validator/assigned-files/${validatorId}`
    );
    console.log("Validator assigned files:", data);
    dispatch(addValidatorDetails(data));
    return data;
  } catch (error) {
    console.error("Error fetching validator assigned files:", error);
    return [];
  }
};

// Fetch projects assigned to validator
export const fetchValidatorProjects = (keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    const data = await apiClient(
      BASE_URL + `api/validatorUser/projects?validatorUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );

    console.log("Validator projects:", data.data);

    // if (data && data.length > 0) {
    //   dispatch(setSelectedAssignedProjectId(data[0].projectId));
    // }
    dispatch(setValidatorProjects(data.data));
    dispatch(setLoading(false));

    return data.data;
  } catch (error) {
    console.error("Error fetching validator projects:", error);
    return [];
  }
};

// Fetch folders for a specific project assigned to validator
export const fetchValidatorFolders = (projectId, keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    console.log(`Fetching folders for validator: ${userId}, project: ${projectId}`);
    const data = await apiClient(
      BASE_URL + `api/validatorUser/folders?projectId=${projectId}&validatorUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );

    console.log("Validator folders:", data.data);

    dispatch(addValidatorAssignedFolders(data.data));

    // if (data && data.length > 0) {
    //   dispatch(setSelectedAssignedFolderId(data[0].folderId));
    // }

    return data.data;
  } catch (error) {
    console.error("Error fetching validator folders:", error);
    return [];
  }
};

// Fetch files for a specific folder assigned to validator
export const fetchValidatorFiles = (folderId, keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    console.log(`Fetching files for validator: ${userId}, folder: ${folderId}`);
    const data = await apiClient(
      BASE_URL + `api/validatorUser/files?folderId=${folderId}&validatorUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );

    console.log("Validator files:", data.data);

    dispatch(addValidatorAssignedFiles(data.data));
    return data.data;
  } catch (error) {
    console.error("Error fetching validator files:", error);
    return [];
  }
};

// Fetch sentences for validation from a specific file
export const fetchSentencesForValidation = (fileId, languageCode) => async (dispatch) => {
  try {
    console.log(`Fetching sentences for validation, file: ${fileId}, language: ${languageCode}`);
    const data = await apiClient(
      BASE_URL + `api/validator/sentences?fileId=${fileId}&languageCode=${languageCode}`
    );

    console.log("Sentences for validation:", data);

    dispatch(setValidatorSelectedFile({
      fileId,
      languageCode,
      sentences: data
    }));

    return data;
  } catch (error) {
    console.error("Error fetching sentences for validation:", error);
    return [];
  }
};

// Submit validation for sentences
export const submitValidation = (validationData) => async (dispatch) => {
  try {
    const state = getState();
    const { token } = state.auth;
    console.log("Submitting validation:", validationData);
    const data = await apiClient(
      BASE_URL + "api/validator/submit-validation",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          "Authorization": `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify(validationData),
      }
    );

    console.log("Validation submission response:", data);

    return data;
  } catch (error) {
    console.error("Error submitting validation:", error);
    throw error;
  }
};


// Mark validation as completed for validator user
export const markValidationCompleted = (fileId, sourceLanguageId, targetLanguageId, validatorUserId) => async (dispatch, getState) => {
  const state = getState();
  const { token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Accept", "*/*");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestBody = {
    fileId: fileId,
    sourceLanguageId: sourceLanguageId,
    targetLanguageId: targetLanguageId,
    validatorUserId: validatorUserId
  };

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    credentials: "include",
    body: JSON.stringify(requestBody),
  };

  try {
    const url = `${BASE_URL}api/validatorUser/mark-validation-completed`;
    console.log("Marking validation completed with URL:", url);
    console.log("Request body:", requestBody);

    const result = await apiClient(url, requestOptions);
    console.log("Mark validation completed API response:", result);

    if (result.status === "success") {
      return { success: true, message: result.message };
    } else {
      console.error("Failed to mark validation as completed:", result);
      return { success: false, message: result.message || "Failed to mark validation as completed" };
    }
  } catch (error) {
    console.error("Error marking validation as completed:", error);
    return { success: false, message: "Network error occurred" };
  }
};